let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("97s9d"), load("7lNQq"), load("gGSRo")]).then(() => parcelRequire('cqeVP'));